module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_--black-opening-page"
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page9",
      "title": "9"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "_ct",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_vm._v("Internal Remedies")]), _vm._v(" "), _c('p', {
    staticClass: "a-head"
  }, [_vm._v("Infusions and Decoctions")]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("Many of a herb’s components, such as its minerals, vitamins, sugars, starches, hormones, tannins, volatile oils, and some alkaloids, dissolve well in water, and for this reason, herbs are often taken as infusions or teas (tisanes). Infusions can be made from the soft green and flowering parts of a herb. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A “strong infusion” indicates a greater measure of herbs to water. You can use a double-strength infusion to make a gargle for a sore throat, for example. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Some herbs have properties such as mucilage and bitter principles that are destroyed by heat, so a cold infusion is made. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Some of the harder, woodier parts of a plant, such as the seeds, roots, buds, and barks of our kitchen spices, need to be boiled in water for a while. This is called a decoction. If the herbs are dried, they should first be pounded into a powder. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx _idGenParaOverride-1"
  }, [_vm._v("Never use an aluminium or copper pan as those metals can react with the brew and taint it.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-head"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page10",
      "title": "10"
    }
  }, [_vm._v("Herb Tea Basic Recipe")])]), _vm._v(" "), _c('p', {
    staticClass: "recipe-ingredients"
  }, [_vm._v("2 teaspoons fresh or 1 teaspoon dried herbs")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-ingredients"
  }, [_vm._v("250 millilitres (1 cup) water")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-instructions"
  }, [_vm._v("Put the herbs in a teapot or a pot with a lid, pour on the boiling water, and infuse for ten to twenty minutes. Strain and sweeten with honey. Drink one to three times daily. A “double-strength” tea would mean using four teaspoons of fresh herbs or two teaspoons of dried herbs to 250 millilitres of water, doubling the quantity of herbs in the recipe. ")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-head"
  }, [_vm._v("Cold Infusion Basic Recipe")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-ingredients"
  }, [_vm._v("2 teaspoons fresh or 1 teaspoon dried herbs")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-ingredients"
  }, [_vm._v("250 millilitres (1 cup) water")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-instructions"
  }, [_vm._v("Using a non-metal container, put in the herbs and water. Close the lid or cover with cling film (plastic wrap) and leave overnight. Strain before use. Take one to three times daily.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("Decoction")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-ingredients"
  }, [_vm._v("2 teaspoons fresh or 1 teaspoon dried herb")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-ingredients"
  }, [_vm._v("250 millilitres (1 cup) water")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-instructions"
  }, [_vm._v("Put the herbs in a pan and pour the water over them. Cover; if possible, let the herbs macerate in the cold water for a few hours. Put the pan on heat, bring to a boil, and simmer gently for fifteen to twenty minutes. Strain. Take one to three times daily.")]), _vm._v(" "), _c('p', {
    staticClass: "a-head"
  }, [_vm._v("Tinctures and Glycerites")]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("These are fluid extracts of herbs using either alcohol or glycerine to extract plant chemicals and preserve them in an easily usable form that can be stored. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Plant constituents are generally more soluble in alcohol than water, and alcohol will dissolve and extract resins, oils, alkaloids, sugars, starches, and hormones, though it does not extract nutrients such as vitamins or minerals. A remedy made this way is called a tincture. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page11",
      "title": "11"
    }
  }, [_vm._v("Brandy or vodka are usually used. Never use alcohols designed for external use, such as rubbing alcohol. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you don’t want to use alcohol for any reason or are formulating remedies for children, you can make a glycerite. I haven’t included many glycerite recipes in the book, but be aware that you can use glycerine to extract phytochemicals from herbs in a similar manner to how alcohol is used to make a tincture, so you can convert the tincture recipes to glycerites. Vegetable glycerine can be purchased from pharmacies or online and is a syrup made from vegetable oil; it is very sweet but doesn’t raise blood sugar, so it is safe for diabetics. Glycerine is a weaker solvent than alcohol, so glycerites won’t be as potent as an alcohol- based tincture and you will need a larger dose for a therapeutic effect. They won’t keep as long as a tincture and are not good at making extractions from hard barks and dried roots. Make sure you use a food-grade vegetable glycerine. ")]), _vm._v(" "), _c('p', {
    staticClass: "b-head-all-lc"
  }, [_vm._v("tincture (folk method)")]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("To make a tincture, put 100 grams of dried herbs or 200 grams fresh herbs into a clean jar and pour on 500 millilitres of vodka or brandy. Seal and keep in a warm place for two to four weeks, shaking daily. Strain through muslin and store in a dark bottle in a cool place for up to two to six years. Because a tincture is much stronger than an infusion or decoction, you only need a few drops in a glass of water as a medicinal dose. Alternatively, a few drops may be added to a salve or bath. ")]), _vm._v(" "), _c('p', {
    staticClass: "b-head-all-lc"
  }, [_vm._v("glycerite (folk method)")]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("To make a glycerite, put 100 grams of dried herbs or 200 grams fresh herbs into a clean jar and pour on 500 millilitres of slightly warmed glycerine. Seal and keep in a warm, dark place for two to four weeks, shaking daily. Strain through muslin and store in a dark bottle in a cool place for about a year. If you add water to your glycerite or use fresh herbs with a lot of water content, it will spoil much faster. Take a teaspoon three times daily. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Glycerine in itself is soothing for a sore throat. Glycerine is used in cosmetic products to soften, moisturise, and plump the skin, so you can use your herbal glycerites externally. Dilute with rose water to use as a skin toner or add to salves, creams, and soaps. ")]), _vm._v(" "), _c('p', {
    staticClass: "a-head"
  }, [_vm._v("Syrups")]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("Some herbs are bitter tasting and are more palatable when taken in the form of syrup, particularly for children. The sugar preserves the herbs. Thick syrup sticks to tissues, bringing the herbal benefits to sore throats and coughs. ")]), _vm._v(" "), _c('p', {
    staticClass: "b-head-all-lc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page12",
      "title": "12"
    }
  }, [_vm._v("syrup (folk method)")])]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("To make syrup, first make your herbal infusion or decoction (see above), then for every 250 millilitres of infusion or decoction, add 250 grams of sugar and heat gently until the sugar is dissolved. Simmer gently until thickened. Pour into sterilised bottles and label. Unopened, this will keep six to twelve months in a cool, dark place. Once opened, keep in the fridge for one to two months. If you wish, you can use honey instead of sugar, though the heating process destroys most of honey’s beneficial properties.")]), _vm._v(" "), _c('p', {
    staticClass: "a-head"
  }, [_vm._v("Herbal Vinegars")]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("By just placing a few sprigs of herbs in vinegar, you can make herbal vinegars that are not only pleasant tasting when sprinkled on salads, but also therapeutic. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("However, you can make a stronger version in the same way that you make a tincture, and this is an alternative to using alcohol. Though vinegar won’t draw out as many phytochemicals from the herbs as alcohol, it does extract the vitamins and minerals from the plants. Acetas, or vinegar extractions, are not as strong as tinctures, so the dose needed is higher. Take two teaspoons three times a day. You can dilute your herbal vinegar with water to take internally, or use it externally in baths and compresses. Acetas generally have a cooling, anti-inflammatory effect, so are useful for conditions such as sore throats and inflamed skin. They will store for one to two years in a cool, dark place.")]), _vm._v(" "), _c('p', {
    staticClass: "note-caution"
  }, [_c('span', {
    staticClass: "Character-Style-1"
  }, [_vm._v("Note:")]), _vm._v(" If you can, use raw cider vinegar."), _c('span', {
    staticClass: "fnref _idGenCharOverride-2"
  }, [_c('span', {
    attrs: {
      "id": "footnote-001-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/HKWH3#footnote-001"
    }
  }, [_vm._v("2")])])]), _vm._v(" Raw cider vinegar (the kind with the mother in it, rather than the barren pasteurised kind) contains antioxidants, vitamins and minerals such magnesium and potassium, and helpful probiotic enzymes and bacteria. It stimulates digestion and has been shown to help lower blood pressure and increase HDL (“good”) cholesterol. Though vinegar is acidic, cider vinegar has an alkaline effect on the body when consumed, which many people believe helps treat arthritis.")]), _vm._v(" "), _c('div', {
    staticClass: "x10"
  }, [_c('p', {
    staticClass: "end-of-section-leaf"
  }, [_c('img', {
    staticClass: "i50",
    attrs: {
      "alt": "leaf",
      "src": "image/2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "a-head"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page13",
      "title": "13"
    }
  }, [_vm._v("Electuaries (Herbal Honey)")])]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("An electuary is simply a herb or spice mixed with honey, so they are incredibly simple to make and will store for one to two years if dried herbs are used, or up to six months if fresh herbs are used (the water content from the fresh plant matter shortens the shelf life). Honey extracts both the water- and oil-based components from the herbs and is soothing and calming when added to a remedy. Take a teaspoonful one to four times a day. ")]), _vm._v(" "), _c('p', {
    staticClass: "a-head"
  }, [_vm._v("Oxymels")]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("Oxymels are a sweet and sour blend of honey and vinegar, combining the benefits of both. If you’ve ever taken apple cider vinegar and honey, you’ve had an oxymel. The easiest way to make a herbal oxymel is to mix an already prepared herbal electuary with a prepared herbal vinegar, generally a fifty-fifty mix. There are several oxymel recipes in this book, but you can come up with your own by simply combining different herb vinegars and electuaries, such as mixing sage electuary with rosemary vinegar, for example. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Another way to make an oxymel is to quarter fill a sterilised jar with dried herbs or half fill with fresh herbs and top up with a fifty-fifty mix of honey and slightly warmed vinegar. Put on a lid and keep in a cool, dark place, shaking daily. (Avoid using a metal lid, as this may be corroded by the vinegar and taint your product.) After two to four weeks, strain through muslin into a sterilised storage bottle. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For a quick way to make an oxymel, you can use the hot method. Simmer your herbs and vinegar together very gently, without boiling, for ten to twenty minutes. Strain out and stir in the honey while the vinegar is still warm. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The usual dosage of an oxymel is one to two teaspoons three or four times a day as needed (when you have a cold, for example). You can put a spoonful of oxymel in warm water and drink that, or even put a spoonful in a glass and top up with sparkling water or tonic water to create a herbal mocktail. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An oxymel should keep at least six to nine months in the fridge. Discard if you notice any mould. ")]), _vm._v(" "), _c('p', {
    staticClass: "contents _idGenParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#_idTextAnchor000"
    }
  }, [_vm._v("[contents]")])]), _vm._v(" "), _c('hr', {
    staticClass: "HorizontalRule-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "_idFootnotes"
  }, [_c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-001"
    }
  }, [_c('p', {
    staticClass: "fn",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/HKWH3#footnote-001-backlink"
    }
  }, [_vm._v("2")]), _vm._v(" For an easy recipe to make your own raw cider vinegar, please see my"), _c('span', {
    staticClass: "ital"
  }, [_vm._v(" Hearth Witch’s Compendium")]), _vm._v(" (Llewellyn, 20"), _c('span', {
    staticClass: "regular-numeral-1-fn _idGenCharOverride-4"
  }, [_vm._v("1")]), _vm._v("7).")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cfc4fe0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HKWH-3.vue
// module id = 78
// module chunks = 0